/* @flow */

import React, { Component } from 'react';
import Immutable from 'immutable';
import uuid from 'uuid';
import * as Api from './api';
import EditorBlocks from './components/EditorBlocks';
import { Segment } from 'semantic-ui-react';

type Props = {
  fetchTemplatesUrl: string,
  mode: CatalogRenderingMode,
  blocks: Array<EditorialBlock>,
  onUpdate: (blocks: Array<EditorialBlock>) => void,
  attached?: boolean,
  locked?: boolean,
  enabledTemplates?: Array<string>,
};

type State = {
  isFetching: boolean,
  templates: Array<EditorialBlockTemplate>,
  diff: List<EditorialBlock>,
};

const mapBlocksToState = blocks =>
  Immutable.Map(blocks.map(b => [b.order, b]))
    .sortBy(b => b.order)
    .toList();

const addBlock = (template, blocks) => {
  const block = {
    id: uuid(),
    template,
    order: blocks.size,
    isNew: true,
  };

  return blocks.push(block);
};

class App extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isFetching: false,
      templates: [],
      diff: mapBlocksToState(props.blocks),
    };
  }

  componentDidMount() {
    const { fetchTemplatesUrl, enabledTemplates } = this.props;

    this.setState({
      isFetching: true,
    });

    const filterTemplates = (
      templates: Array<EditorialBlockTemplate>
    ): Array<EditorialBlockTemplate> => {
      if (enabledTemplates != null) {
        return templates.filter(tpl => enabledTemplates.indexOf(tpl.code) > -1);
      } else {
        return templates;
      }
    };

    Api.fetchTemplates(fetchTemplatesUrl).then(templates =>
      this.setState({
        isFetching: false,
        templates: filterTemplates(templates),
      })
    );
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.blocks !== this.props.blocks) {
      this.setState({
        diff: mapBlocksToState(nextProps.blocks),
      });
    }
  }

  addBlock = (contentType: EditorialBlockType) => {
    this.setState(
      prevState => ({
        diff: addBlock(contentType, prevState.diff),
      }),
      this.notifyUpdate
    );
  };

  updateBlocks = (blocks: List<EditorialBlock>) => {
    this.setState(
      {
        diff: blocks,
      },
      this.notifyUpdate
    );
  };

  notifyUpdate = () => {
    const { diff } = this.state;

    this.props.onUpdate(diff.toArray());
  };

  render() {
    const { mode, attached, locked } = this.props;
    const { isFetching, templates, diff } = this.state;

    if (isFetching) {
      return <Segment loading style={{ minHeight: '180px' }} />;
    }

    return (
      <div>
        <EditorBlocks
          mode={mode}
          templates={templates}
          blocks={diff}
          onAdd={this.addBlock}
          onUpdate={this.updateBlocks}
          attached={attached}
          locked={locked}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/modules/edito/App.js